import { render } from "./DevelopedByWithLogo.vue?vue&type=template&id=026490bc"
const script = {}

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__